import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';

const CARE_CREDIT_IN_OFFICE_RESTRICTED_STATES = ['CA', 'CT', 'IL'];

type UseCareCreditRestrictionsCheckProps = {
  locationId: string | undefined;
  isCareCreditEnabled: boolean;
};

export const useCareCreditRestrictionsCheck = ({
  locationId,
  isCareCreditEnabled,
}: UseCareCreditRestrictionsCheckProps) => {
  const { data: merchantData } = CareCreditIntegrationV1.Queries.useGetMerchantConnectionQuery({
    request: { locationId },
    options: { enabled: isCareCreditEnabled },
  });

  const isCareCreditRestrictedState = CARE_CREDIT_IN_OFFICE_RESTRICTED_STATES.includes(merchantData?.state ?? '');

  return { isCareCreditRestrictedState };
};
